import {
  DASHBOARD_CONTEXT,
  DASHBOARD_LAYOUT_CELL_INSERT_DIRECTION,
  DASHBOARD_LAYOUT_ROW_ID_PARAM,
  DASHBOARD_TO_ADD_TO_PARAM,
  REDIRECT_TO,
  SHOULD_CLONE_DASHBOARD,
} from '@modules/analysis/constants';
import { NAV_PATHS } from '@modules/common/constants';
import { Direction } from '@modules/common/types';
import { AnalysisUseCase } from 'generated/graphql';
import { DashboardState } from '../store/types';
import { EditableDashboardListItem } from '../types';

interface getAddNewAnalysisToDashboardRouteParams {
  dashboard: Pick<
    EditableDashboardListItem,
    'id' | 'viewToken' | 'editToken' | 'title' | 'metadataV2' | 'version'
  >;
  useCase: AnalysisUseCase;
  rowID?: string;
  cellInsertDirection: Direction;
  context: DashboardState['visual']['context'];
}

export const getAddNewAnalysisToDashboardRoute = ({
  cellInsertDirection,
  dashboard,
  useCase,
  rowID,
  context,
}: getAddNewAnalysisToDashboardRouteParams) => {
  const unencodedJSON = JSON.stringify({
    id: dashboard.id,
    viewToken: dashboard.viewToken,
    editToken: dashboard.editToken,
    title: dashboard.title,
    metadataV2: dashboard.metadataV2,
  });
  const uriComponent = encodeURIComponent(unencodedJSON);
  const base64JSON = window.btoa(uriComponent);

  const params = new URLSearchParams();
  params.append(DASHBOARD_TO_ADD_TO_PARAM, base64JSON);
  rowID && params.append(DASHBOARD_LAYOUT_ROW_ID_PARAM, rowID);

  params.append(DASHBOARD_CONTEXT, context);

  if (context === 'Home') {
    params.append(REDIRECT_TO, encodeURIComponent(`/${NAV_PATHS.HOME}`));
    params.append(SHOULD_CLONE_DASHBOARD, String(true));
  } else if (context === 'Customize Home') {
    params.append(
      REDIRECT_TO,
      encodeURIComponent(`/${NAV_PATHS.CUSTOMIZE_HOMEPAGE}`),
    );
  }

  params.append(
    DASHBOARD_LAYOUT_CELL_INSERT_DIRECTION,
    cellInsertDirection.toString(),
  );

  if (useCase === AnalysisUseCase.Compare) {
    return `/${NAV_PATHS.COMPARE}?${params.toString()}`;
  }

  if (useCase === AnalysisUseCase.Feed) {
    return `/${NAV_PATHS.FEED}?${params.toString()}`;
  }

  return `/${NAV_PATHS.QUANTIFY}?${params.toString()}`;
};
